<template>
  <div class="col-sm-6" style="padding-right: 0;">
    <vc-date-picker locale="nl-NL" mode="range" v-model="filter.value" v-on:input="emitToggleEvent()" />
  </div>
</template>

<script>
export default {
  name: 'DateRangeFilter',
  props: ['filter'],
  data: function() {
    return {
      data: '',
      range: {
        start: new Date(this.filter.value.start),
        end: new Date(this.filter.value.end)
      }
    };
  },
  beforeMount() { },
  methods: {
    emitToggleEvent() {
      this.$emit('toggle-value');
    }
  }
};
</script>

<style scope>
.vc-text-base{
  font-size: 12px !important;
  padding: 0.25rem 0.5rem !important;
  height: 28px;
}
</style>
